import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry(() => import("./patients-page"), {
  testId: "rd-patients-loading",
  shell: { activeNav: "patients" },
});
